export enum INTEGRATIONS_TABLES {
  Integrations = "Integrations",
  IntegrationsApi = "Integrations api",
  AnalysisProviders = "Analysis providers"
}

export enum INTEGRATION_FIELD_NAMES {
  SelectedCompany = "selectedCompany",
  Name = "name",
  FileFormat = "fileFormat",
  VehicleFolderNaming = "vehicleFolderNaming",
  DriverFolderNaming = "driverFolderNaming",
  Host = "host",
  Port = "port",
  RemotePath = "remotePath",
  Username = "username",
  Password = "password",
  IncludeSubCompanies = "includeSubCompanies",
  SyncHistoricalFiles = "syncHistoricalFiles",
  Enabled = "enabled"
}

export enum DEFAULT_FIELD_VALUES {
  Password = "******"
}

export enum VEHICLES_FOLDER_NAMING_VALUES {
  Imei = "Imei",
  VehicleNumber = "VehicleNumber"
}

export enum DRIVER_FILE_DESTINATION_VALUES {
  VehicleFolder = "UnderVehicleFolder",
  DriverFolder = "DriverId"
}

export enum INTEGRATION_TYPE {
  Sftp = "Sftp",
  Api = "Api",
  AnalysisProvider = "AnalysisProvider"
}

export enum API_KEY_FIELD_NAMES {
  Name = "name",
  SelectedCompany = "selectedCompany",
  ExpirationDate = "expirationDate",
  Enabled = "enabled"
}

export enum ANALYSIS_PROVIDER_NAMES {
  Convey = "Convey",
  VDO = "VdoFleet"
}

export enum ANALYSIS_RPOVIDER_DISPLAY_NAMES {
  Convey = "Convey",
  VDO = "VDO Fleet"
}

export enum CONVEY_INTEGRATION_FIELD_NAMES {
  EndpointUrl = "endpointUrl",
  Username = "username",
  Password = "password",
  SelectedCompany = "selectedCompany",
  Name = "name",
  Enabled = "enabled",
  IncludeSubCompanies = "includeSubCompanies"
}

export enum VDO_INTEGRATION_FIELD_NAMES {
  AccountId = "username",
  ApiKey = "password",
  SelectedCompany = "selectedCompany",
  Name = "name",
  FileFormat = "fileFormat",
  Enabled = "enabled",
  IncludeSubCompanies = "includeSubCompanies"
}
